import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import useCategories from "../../../utils/useCategories";
import { disableSwitcher } from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { reimbursementTxnRequestSuccessDetail } from "../../../redux/features/reimbursementTransaction";

// Component
import StatusContainer from "../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import accountNameStandardised from "../../../utils/accountNamestandardised";
import FormatAmount from "../../../components/_utils/FormatAmount/FormatAmount";
import { formatAccountNumber } from "../../../components/_utils/FormatAccountNumber";
import TEXT from "../../../utils/globalText";
import { fieldForceTxnRequestSuccessDetail } from "../../../redux/features/fieldForceTransaction";
import { toast } from "react-toastify";
import { toast_position } from "../../../redux/features/Settings/Authorization";

const FieldForceTxnSuccess = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { id } = useParams();
  const {
    fieldForceTxnSuccessRequestData,
    fieldForceTxnSuccessRequestLoading,
  } = useSelector((state) => state.fieldForceTransaction);

  const categoryMapper = useCategories();
  const location = useLocation();
  const Requestlocation = location?.state;

  useEffect(() => {
    dispatch(disableSwitcher());
  }, []);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(fieldForceTxnRequestSuccessDetail(id));
  }, [id]);

  const viewDetailsHandler = () => {
    // navigate(
    //   `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${fieldForceTxnSuccessRequestData?.request?.[0]?.transactions?.txn_id}`,
    // );
    toast.info("Feature coming soon", toast_position);
  };

  const createAccountHandler = () => {
    navigate(
      "/field_force_transaction_dashboard/create_field_force_transaction",
    );
  };

  const dashboardHandler = () => {
    navigate("/field_force_transaction_dashboard");
  };

  // Button

  const buttonRows = [
    [
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/view_details.svg",
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "white",
      },
    ],
  ];

  const RequestbuttonRows = [
    [
      {
        btnText: "View request details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/view_details.svg",
        handleFunction: () =>
          navigate(
            `/field_force_transaction_dashboard/field_force_request_view_all/field_force_request_detail_page/${Requestlocation?.Request_id}`,
          ),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View transaction details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/view_details.svg",
        handleFunction: () => {
          // navigate(
          //   `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${fieldForceTxnSuccessRequestData?.request?.[0]?.transactions?.txn_id}`,
          // );
          toast.info("Feature coming soon", toast_position);
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      // {
      //   btnText: "View details",
      //   enabledBgColor: "var(--text-primary)",
      //   enabledTextColor: "var(--positive-bg)",
      //   icon: "https://q2pay.in/new_assets/common/create_flow/view_details.svg",
      //   handleFunction: viewDetailsHandler,
      //   iconToBeAlign: "left",
      //   fullWidthRequired: true,
      //   imgColor: "var(--positive-bg)",
      // },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  return (
    <>
      <StatusContainer
        isLoading={fieldForceTxnSuccessRequestLoading}
        status="success"
        hoverOption="white"
        title={`${
          Requestlocation?.type === "PayReimburseTxn"
            ? "Request approved and transaction created successfully."
            : "Field force transaction created successfully."
        }`}
        buttonRows={
          Requestlocation?.type === "PayReimburseTxn"
            ? RequestbuttonRows
            : buttonRows
        }
      >
        <TabsWeapperSection title="Request details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountNameStandardised(
                    fieldForceTxnSuccessRequestData?.request[0]
                      ?.field_force_account_name,
                  ),
                  leftSubTitle: "Account name",
                  hasRight: true,
                  rightText: true,
                  rightTitleTextColor: "var(--text-primary)",
                  rightTitle: (
                    <>
                      INR{" "}
                      <FormatAmount
                        price={
                          fieldForceTxnSuccessRequestData?.request[0]?.amount
                        }
                      />
                    </>
                  ),
                  rightTextFontWeight: "semibold",
                  rightSubTitle: "Amount",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              onClick={() =>
                navigate(
                  `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${fieldForceTxnSuccessRequestData?.request[0]?.field_force_account_id}`,
                )
              }
              //   handleFunction={}
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    fieldForceTxnSuccessRequestData?.request[0]
                      ?.field_force_account_bank_acc_no,
                  ),
                  leftSubTitle: TEXT?.DESTINATION_ACCOUNT_NUMBER,
                  ifsc: fieldForceTxnSuccessRequestData?.request[0]
                    ?.field_force_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
              hoverable="black"
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    fieldForceTxnSuccessRequestData?.request[0]?.category,
                  leftSubTitle: "Transaction category",
                  icon: categoryMapper(
                    fieldForceTxnSuccessRequestData?.request[0]?.category,
                  ),
                },
              ]}
            />

            {/* We dont get data for backend */}
            {/* <InfoCard
              bgColor="var(--positive-card)"
              onClick={() =>
                navigate(
                  `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${fieldForceTxnSuccessRequestData?.request[0]?.owner_account_id}`,
                )
              }
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    fieldForceTxnSuccessRequestData?.request[0]
                      ?.owner_account_bank_acc_no,
                  ),
                  leftSubTitle: TEXT?.SOURCE_ACCOUNT_NUMBER,
                  ifsc: fieldForceTxnSuccessRequestData?.request[0]
                    ?.owner_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
              hoverable="black"
            /> */}
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </>
  );
};

export default FieldForceTxnSuccess;
